import { create } from "zustand";

export const useLoadingStore = create<any>()((set) => ({
  isLoading: false,
  setIsLoading: (loading: boolean) => set({ isLoading: loading }),
  // 'default' = 通常スピナー / 'analyzing' = 解析中の専用アニメ
  variant: 'default',
  setVariant: (variant: 'default' | 'analyzing') => set({ variant })
}));
